function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { GridRow, Icon } from "../";
export const Message = ({
  children,
  color = "yellow",
  open,
  setOpen,
  timeout,
  ...props
}) => {
  const portal = useRef();
  const [id] = useState(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
  useEffect(() => {
    if (timeout) {
      setTimeout(() => setOpen(false), timeout);
    }

    const target = document.createElement("div");
    target.id = `portal${id}`;
    document.body.appendChild(target);
    portal.current = document.getElementById(`portal${id}`);
    return () => {
      document.getElementById(`portal${id}`).remove();
    };
  }, []);
  return portal.current && open ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(Container, _extends({
    color: color
  }, props, {
    yStart: true
  }), children, /*#__PURE__*/React.createElement(CloseIcon, {
    onClick: () => {
      setOpen(false);
    },
    platform: true,
    name: "Close"
  })), portal.current) : "";
};
const Container = styled(GridRow)`
  background-color: ${props => props.theme.palette[props.color].lightest};
  padding: 16px 88px 16px 24px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 500;
`;
const CloseIcon = styled(Icon)`
  cursor: pointer;
  position: absolute;
  right: 40px;
`;